/* RevRunners: layout-only EasySearch action alignment.
   Keeps the original nodes, labels, values, event handlers and app behaviour.
   CSS flattens layout wrappers; no controls are moved or cloned. */
(function () {
  'use strict';
  if (window.__rrFitmentActionsV2) { window.__rrFitmentActionsV2.scan(); return; }
  const watched = new Map();
  const legacy = ['rrf-control-row','rrf-control-field','rrf-control-action','rrf-control-extra','rrf-field-group','rrf-group-path','rrf-select-grid','rrf-primary-control','rrf-clear-control'];
  const classes = [...legacy, 'rrfa-grid','rrfa-contents','rrfa-stretch','rrfa-field','rrfa-field-1','rrfa-field-2','rrfa-field-3','rrfa-field-4','rrfa-primary','rrfa-clear','rrfa-garage','rrfa-extra'];
  const own = new Set(classes);
  const selector = classes.map(c => '.' + c).join(',');
  const shown = el => !el.closest('[hidden]') && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const label = el => String(el.matches('input') ? el.value : el.textContent || '').replace(/\s+/g, ' ').trim();
  const clickable = 'button,input[type="submit"],input[type="button"],input[type="reset"],a,[role="button"]';
  function action(container, pattern) {
    const candidates = [...container.querySelectorAll(clickable + ',div,span')]
      .filter(el => shown(el) && !el.querySelector('select') && pattern.test(label(el)));
    return candidates.find(el => el.matches(clickable)) ||
      candidates.find(el => el.hasAttribute('onclick') || el.hasAttribute('tabindex') || /easysearch.*(?:btn|button|search)/i.test(el.className)) ||
      candidates[0] || null;
  }
  function ancestor(nodes, boundary) {
    let el = nodes[0] && nodes[0].parentElement;
    while (el && boundary.contains(el)) {
      if (nodes.every(node => el.contains(node))) return el;
      if (el === boundary) break;
      el = el.parentElement;
    }
    return null;
  }
  function field(select, container) {
    let el = select.parentElement, fallback = el;
    while (el && el !== container && el.querySelectorAll('select').length === 1) {
      if (el.querySelector('label') || el.matches('label')) return el;
      el = el.parentElement;
    }
    return fallback;
  }
  function decorate(root) {
    root.querySelectorAll('.easysearch-container').forEach(container => {
      container.querySelectorAll(selector).forEach(el => el.classList.remove(...classes));
      container.classList.remove(...classes);
      const selects = [...container.querySelectorAll('select')].filter(shown);
      const search = action(container, /^(?:search|find (?:parts|products)|view results)(?:\s*[>\u2192\u203a])?$/i);
      const clear = action(container, /^(?:clear(?: filters)?|reset(?: selections| filters)?)$/i);
      const garage = action(container, /^(?:[+\uFF0B\u2795]\s*)?(?:add|save)(?: vehicle)? to (?:my |your )?garage$/i);
      if (search) search.classList.add('rrf-primary-control');
      if (clear) clear.classList.add('rrf-clear-control');
      if (selects.length !== 4 || !search) return;
      const fields = selects.map(el => field(el, container));
      const controls = [search, clear, garage].filter(Boolean);
      const targets = [...fields, ...controls];
      if (fields.some(el => !el) || new Set(targets).size !== targets.length) return;
      if (targets.some(el => targets.some(other => el !== other && el.contains(other)))) return;
      const row = ancestor(targets, container);
      if (!row) return;
      // Only transparent layout ancestors are flattened; controls and their labels remain intact.
      const wrappers = new Set();
      for (const target of targets) {
        for (let el = target.parentElement; el && el !== row; el = el.parentElement) wrappers.add(el);
      }
      if ([...wrappers].some(el => /^(DETAILS|DIALOG|TABLE|TR|TD|BUTTON|A|LABEL)$/.test(el.tagName))) return;
      row.classList.add('rrfa-grid');
      wrappers.forEach(el => el.classList.add('rrfa-contents'));
      for (let el = row.parentElement; el && container.contains(el); el = el.parentElement) {
        el.classList.add('rrfa-stretch');
        if (el === container) break;
      }
      fields.forEach((el, i) => el.classList.add('rrfa-field', 'rrfa-field-' + (i + 1)));
      search.classList.add('rrfa-primary');
      if (clear) clear.classList.add('rrfa-clear');
      if (garage) garage.classList.add('rrfa-garage');
      // Preserve any app messages or other siblings without squeezing the search controls.
      const markExtras = parent => [...parent.children].forEach(el => {
        if (targets.includes(el)) return;
        if (wrappers.has(el)) { markExtras(el); return; }
        if (!/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName) && !el.matches('input[type="hidden"]')) el.classList.add('rrfa-extra');
      });
      markExtras(row);
    });
  }
  function schedule(entry, root) {
    cancelAnimationFrame(entry.frame);
    entry.frame = requestAnimationFrame(() => { if (root.isConnected) decorate(root); });
  }
  const appClasses = value => String(value || '').split(/\s+/).filter(c => c && !own.has(c)).sort().join(' ');
  function scan() {
    watched.forEach((entry, root) => {
      if (!root.isConnected) { entry.observer.disconnect(); cancelAnimationFrame(entry.frame); watched.delete(root); }
    });
    document.querySelectorAll('[data-rr-fitment-layout]').forEach(root => {
      if (watched.has(root)) { schedule(watched.get(root), root); return; }
      const entry = {frame:0, observer:null};
      entry.observer = new MutationObserver(changes => {
        if (changes.some(change => change.type !== 'attributes' || change.attributeName !== 'class' ||
          appClasses(change.oldValue) !== appClasses(change.target.getAttribute('class')))) schedule(entry, root);
      });
      entry.observer.observe(root, {subtree:true,childList:true,characterData:true,attributes:true,
        attributeFilter:['hidden','style','class','disabled'],attributeOldValue:true});
      watched.set(root, entry); schedule(entry, root);
    });
  }
  const resize = () => watched.forEach((entry, root) => schedule(entry, root));
  window.__rrFitmentActionsV2 = {scan};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true}); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(scan));
  window.addEventListener('resize', resize, {passive:true});
})();
